import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { IconButton, CircularProgress, Skeleton } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

const Box = ({
  title,
  icon,
  onAddHandler,
  besideAddIconText,
  count,
  children,
  dragHandleProps,
  isLoading = false,
  canAdd = true,
}) => (
  <div className="workbench-box">
    <div className="workbench-box-header">
      <div className="workbench-box-title">
        {dragHandleProps && (
          <div {...dragHandleProps} style={{ display: 'flex', alignItems: 'center', cursor: 'grab' }}>
            <DragIndicatorIcon style={{ marginRight: '4px' }} />
          </div>
        )}
        <img
          src={`${process.env.PUBLIC_URL}/${icon}`}
          alt={title}
          height={24}
          width={24}
          style={{ margin: 0, padding: 0 }}
        />
        <p style={{ margin: '0px', padding: '0px' }}>
          {isLoading ? (
            <Skeleton variant="text" width={100} height={20} />
          ) : (
            <>
              {count > 0 && count} {title}
            </>
          )}
        </p>
      </div>

      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 2 }}>
        <span>{besideAddIconText}</span>
        {canAdd && (
          <IconButton color="inherit" onClick={onAddHandler} size="small">
            <AddCircleOutlineOutlinedIcon />
          </IconButton>
        )}
      </div>
    </div>

    <div className="workbench-box-content">
      {isLoading ? (
        <div style={{ padding: '16px', marginTop: '50%', textAlign: 'center' }}>
          <CircularProgress size={24} style={{ color: '#000' }} />
        </div>
      ) : (
        children
      )}
    </div>
  </div>
);

export default Box;
